import { ImmerReducer, createActionCreators, createReducerFunction } from 'immer-reducer';
import { IMiddleAreaState } from '../../interfaces/states/IMiddleAreaState';

const initialState: IMiddleAreaState = {
  tabValue: 0,
  salesKeypad: true,
};

class MiddleAreaReducer extends ImmerReducer<IMiddleAreaState> {
  public setMiddleAreaState(state: Partial<IMiddleAreaState>): void {
    this.draftState = { ...this.draftState, ...state };
  }

  public showActionWindow(): void {
    this.draftState = {
      ...this.draftState,
      tabValue: 0,
      salesKeypad: true,
    };
  }

  public setKeypadVisibility(open: boolean): void {
    this.draftState.salesKeypad = open;
  }

  public resetState(): void {
    this.draftState = initialState;
  }
}

export const MiddleAreaActions = createActionCreators(MiddleAreaReducer);
export const MiddleAreaReducerFunction = createReducerFunction(MiddleAreaReducer, initialState);
